const adCreditsDisclaimerTextSimplified =
  '*Spend $30 in your first 7 days to receive a $20 refund on your bill. There’s a 1 offer limit per account. New accounts only. You must be a legal resident of the 50 United States or DC, and at least 18 years old to be eligible for this offer.';
export default adCreditsDisclaimerTextSimplified;
